export default __webpack_public_path__ + "static/media/bestehotel.3d8d4d96.jpg";